/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {FC, useState} from 'react'
import {Redirect, Switch, Route} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {Logout, AuthPage} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
// import {RootState} from '../../setup'
import {MasterInit} from '../../_metronic/layout/MasterInit'
import {RootState} from '../../reducer/reducer'
import WelcomeToRegister from '../modules/auth/WelcomeRegister'
import {AuthHandle} from './AuthHandle'
import {LayoutProvider} from '../../_metronic/layout/core'

const Routes: FC = () => {

  const AuthStatus = useSelector((state:RootState) => {
    return state.Auth
  })
  console.log('auth', AuthStatus)
  // const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  // const isAuthorized = AuthStatus


  return (
    <>
      <Switch>
        <Route path={'/welcome'} component={WelcomeToRegister} />
        {!AuthStatus ? (
          /*Render auth page when user at `/auth` and not authorized.*/
          <Route>
            <AuthPage />
          </Route>
        ) : (
          /*Otherwise redirect to root page (`/`)*/
          <Redirect from='/auth' to='/' />
        )}
        <Route path='/error' component={ErrorsPage} />
        <Route path='/logout' component={Logout} />
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      </Switch>
      <MasterInit />
    </>
  )
}

export {Routes}
